import PlanningView from "./PlanningView.vue"

const base = "/planning"

export default [
    {
        path: base,
        name: "planningview",
        component: PlanningView
    }
]
